module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAccessToContributors && _vm.contributors) ? _c('div', {
    staticClass: "grid-narrow-left-column SectionBorderTop"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("Forecast Managers")]), _vm._v(" "), _vm._l((_vm.contributors.forecastManagers), function(fcm, index) {
    return _c('div', {
      key: ("fcm+" + index)
    }, [_c('MailIcon', {
      staticClass: "mailIcon"
    }), _c('a', {
      attrs: {
        "href": ("mailto:" + (fcm.email))
      }
    }, [_vm._v(_vm._s(fcm.name))])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(_vm.forecastWindow.multiValidation) ? [_c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("Export Managers")]), _vm._v(" "), _vm._l((_vm.contributors.zonesSupervisors), function(zs, index) {
    return _c('div', {
      key: ("zs+" + index)
    }, [_c('MailIcon', {
      staticClass: "mailIcon"
    }), _c('a', {
      attrs: {
        "href": ("mailto:" + (zs.email))
      }
    }, [_vm._v(_vm._s(zs.name))])], 1)
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("Contributors")]), _vm._v(" "), _vm._l((_vm.contributors.zoneForecasters), function(zf, index) {
    return _c('div', {
      key: ("zf+" + index)
    }, [_c('MailIcon', {
      staticClass: "mailIcon"
    }), _c('a', {
      attrs: {
        "href": ("mailto:" + (zf.email))
      }
    }, [_vm._v(_vm._s(zf.name))])], 1)
  }), _vm._v(" "), (_vm.contributors.zoneReaders.length > 0) ? [_c('div', {
    staticClass: "SectionTitle",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Readers")]), _vm._v(" "), _vm._l((_vm.contributors.zoneReaders), function(zf, index) {
    return _c('div', {
      key: ("zr+" + index)
    }, [_c('MailIcon', {
      staticClass: "mailIcon"
    }), _c('a', {
      attrs: {
        "href": ("mailto:" + (zf.email))
      }
    }, [_vm._v(_vm._s(zf.name))])], 1)
  })] : _vm._e()], 2)])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f80b6dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/Contributors.vue
// module id = 3294
// module chunks = 0